"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _axios = _interopRequireDefault(require("@/utils/axios"));
var _useCostItem = require("./useCostItem");
var _tree = require("@ys/utils/lib/tree");
var _antDesignVue = require("ant-design-vue");
const treeSelectProps = _.cloneDeep(_antDesignVue.TreeSelect.props);
// 删除已在当前组件进行重写的属性
delete treeSelectProps.loading;
delete treeSelectProps.searchValue;
delete treeSelectProps.open;
delete treeSelectProps.treeData;
var _default = exports.default = {
  name: 'CostItemTreeSelect',
  // 科目选择器组件 => 通过树形下拉选择列表的方式实现对科目的单选或多选
  props: {
    ...treeSelectProps,
    // 带 class_ 或 item_ 前缀
    value: {
      type: [String, Array],
      default: () => []
    },
    // 指定默认选中的条目 必须携带“class_”或者“item_”前缀
    defaultValue: {
      type: [String, Array],
      default: undefined
    },
    placeholder: {
      type: String,
      default: '请选择科目'
    },
    // 显示清除按钮
    allowClear: {
      type: Boolean,
      default: true
    },
    // 最多显示多少个 tag
    maxTagCount: {
      type: Number,
      default: 3
    },
    // 在下拉中显示搜索框(仅在单选模式下生效)
    showSearch: {
      type: Boolean,
      default: true
    },
    // 搜索框默认文字
    searchPlaceholder: {
      type: String,
      default: '请输入关键词搜索'
    },
    // 显示 checkbox 默认false
    treeCheckable: {
      type: Boolean,
      default: true
    },
    // 支持多选（当设置 treeCheckable 时自动变为 true）
    multiple: {
      type: Boolean,
      default: true // 如果是单选模式，禁用所有分类，仅可选择科目
    },
    // 替换 treeNode 中 title,value,key,children 字段为 treeData 中对应的字段
    // {children:'children', title:'title', key:'key', value: 'value' }
    replaceFields: {
      type: Object,
      default: () => {
        return {
          children: '_children',
          title: '_title',
          value: '_value'
        };
      }
    },
    // 定义选中项回填的方式。TreeSelect.SHOW_ALL: 显示所有选中节点(包括父节点). TreeSelect.SHOW_PARENT: 只显示父节点(当父节点下所有子节点都选中时). 默认只显示子节点. TreeSelect.SHOW_CHILD
    showCheckedStrategy: {
      type: String,
      default: 'SHOW_CHILD' // SHOW_ALL / SHOW_PARENT / SHOW_CHILD
    },
    // 自定义属性 - 获取列表的接口参数 {isDefault: 费用项是否默认，1-是，0-否, type: 类型，Default：原子科目，CustomFormula：复合科目，BizCalculate：二次计算科目，Stat：统计科目; dimension: 统计维度，Shop：店铺，Anchor：主播，Sku：单品}
    params: {
      type: Object,
      default: () => {}
    },
    // 自定义属性 - 获取列表的请求方法
    method: {
      type: [Function, String],
      default: '/v1/cost/class/item' // 最新科目分类及科目查询接口/v1/cost/class/item，在“业绩解码”和“租户后台”项目都存在该接口且为常用接口，故设置为默认值
    },
    // 自定义属性 - 选择框宽度
    width: {
      type: String,
      default: '100%'
    },
    // 自定义属性 - 限制最多能选择多少个科目，0表示不限制
    limit: {
      type: Number,
      default: 0
    },
    // 是否切换缓存页面时，重刷数据
    reloadByActivated: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      selectedNode: undefined,
      // 当前选中的值，和 props.value 保持一致
      rawData: [],
      // 未经格式转换的原始数据
      transformedData: [],
      // 经过格式转换后的最终用于展示的数据
      searchValue: '',
      // 当前的搜索条件
      searchValueOld: undefined // 上一次的搜索条件，用于选择节点后自动回填到输入框，保证选择框不收起
    };
  },
  computed: {
    // 转换数据的配置参数
    transformOptions() {
      const {
        multiple,
        treeCheckable
      } = this;
      return {
        multiple: treeCheckable ? true : multiple
      };
    }
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (!this.defaultValue) this.selectedNode = val || undefined;
        // 清空
        if (_.isEmpty(val) && !_.isEmpty(oldVal)) this.clearSearchValue();
      },
      immediate: true
    },
    selectedNode(val) {
      this.$emit('input', val);
    },
    searchValue: {
      handler(newVal, oldVal) {
        // 清空输入框时才更新
        if (!newVal && oldVal && this.searchValueOld !== oldVal) this.searchValueOld = oldVal;
      },
      immediate: true
    },
    transformedData: {
      async handler(val) {
        if (_.size(val)) {
          // 默认值及v-model的值初始化回填
          const initValue = this.defaultValue || this.value;
          if (!_.isEmpty(initValue)) {
            const res = await this.handleChange(initValue, undefined, undefined, false);
            this.$emit('ready', res);
            console.log('ready', res);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  activated() {
    console.log('activated');
    // 为了从其他页面切换回来当前页加载最新数据，确保数据的实时性
    if (this.reloadByActivated) {
      this.reload();
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    // 清空搜索词 - 供外部使用，勿修改命名
    clearSearchValue() {
      this.searchValue = null;
      this.searchValueOld = null;
    },
    //  供外部组件手动调用更新数据，勿修改命名
    reload() {
      // 避免同时存在多个请求
      if (this.loading) return;
      this.selectedNode = undefined;
      this.transformedData = [];

      // nextTick 确保selectedNode和transformedData已经清空完毕，且界面已经更新，否则会出现输入框文字错乱的问题
      this.$nextTick(() => this.getDataList());
    },
    // 获取科目数据
    async getDataList() {
      try {
        this.loading = true;
        const res = typeof this.method === 'function' ? await this.method(this.params) : await _axios.default.get(this.method, this.params);
        this.init(res.classes || res);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async init(rawData) {
      try {
        this.loading = true;
        this.rawData = _.cloneDeep(rawData);
        this.transformedData = await (0, _useCostItem.transformRawData)(rawData, this.transformOptions);
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    // 自定义搜索逻辑
    handleFilterTreeNode(inputValue, treeNode) {
      const _title = treeNode.data.props._title;
      return _title && _title.indexOf(inputValue.trim()) > -1;
    },
    /**
     * 选中树节点时调用此函数 function(value, label, extra)
     * @param {object} params
     * @param {string|array} params.value treeCheckable为true时value为数组、否则为字符串。节点对应的value值，会带有“biz_”或“shop_”前缀
     * @param {array} params.label 节点对应显示的标题
     * @param {object} params.extra {preValue:[],selected:true（treeCheckable为false时才有该参数），allCheckedNodes:[选中的节点]（treeCheckable为true时才有该参数）,triggerNode:{} //实际应用中可通过 triggerNode.dataRef 获取当前选择的节点及其所有下级,triggerValue:''}
     * @param {boolean} params.triggerEmit 是否触发this.$emit('change', res)事件
     */
    // eslint-disable-next-line max-statements
    handleChange(value, label, extra, triggerEmit = true) {
      // 只传了value，没传label的情况=》父组件传入defaultValue或v-model作为默认值手动调用方法
      // 自动补全label
      if (value && !label) {
        const {
          transformedData
        } = this;
        if (Array.isArray(value)) {
          // 多选
          const arr = (0, _tree.findNodeAll)(transformedData, node => value.includes(node._value), _useCostItem.TREE_CONFIG);
          const tempValue = arr.map(item => item._value);
          const tempLabel = arr.map(item => item._title);

          // 取交集
          const xorValues = _.xorBy(tempValue, value);
          value = [...tempValue, ...xorValues];
          label = [...tempLabel, ...xorValues];
        } else {
          // 单选
          const targetNode = (0, _tree.findNode)(transformedData, node => value === node._value, _useCostItem.TREE_CONFIG);
          if (targetNode) {
            value = targetNode._value;
            label = targetNode._title;
          }
        }
      }
      let res = {
        value,
        label,
        extra
      };
      // treeCheckable 或 multiple 为 true 时 value 返回数组，否则返回字符串
      if (Array.isArray(value)) {
        const {
          limit
        } = this;
        if (limit > 0 && value.length > limit) {
          value = value.slice(0, limit);
          label = label.slice(0, limit);
          _antDesignVue.message.warn({
            key: 'limit',
            content: `最多只能同时选择${limit}个科目，超出部分将被自动过滤掉`
          });
        }
        const itemIds = [];
        const itemLabels = [];
        const classIds = [];
        const classLabels = [];
        value.forEach((item, index) => {
          if (item.startsWith('item_')) {
            itemIds.push(item.split('_')[1]);
            itemLabels.push(label[index]);
          } else {
            classIds.push(item.split('_')[1]);
            classLabels.push(label[index]);
          }
        });

        // 返回的数据改成了对象，可通过对象解构进行获取
        // 比官方文档扩充返回参数： itemIds, itemLabels, classIds, classLabels
        res = {
          value,
          label,
          extra,
          itemIds,
          itemLabels,
          classIds,
          classLabels
        };
      } else {
        res.value = value ? value.split('_')[1] : value;
        res.label = label[0];
        res.isItem = value ? value.startsWith('item_') : value;
      }
      if (triggerEmit) {
        this.$emit('change', res);
        console.log('change', res);
      }
      this.selectedNode = value;
      return res;
    },
    // 文本框值变化时回调 function(value: string)
    handleSearch(value) {
      this.$emit('search', value);
    },
    // 展开节点时调用 function(expandedKeys)
    handleTreeExpand(expandedKeys) {
      this.$emit('treeExpand', expandedKeys);
    },
    // 获得焦点
    handleBlur() {
      // 收起后再打开，清空旧值，相当于重新开始
      this.searchValueOld = this.searchValue;
    }
  }
};